export const UPDATE_ASSOCIATION_MODAL_STATES = {
  PRIMARY_MODAL_PRIMARY_STATE: 'PRIMARY_MODAL_PRIMARY_STATE',
  PRIMARY_MODAL_SECONDARY_PRIMARY_EXISTS_STATE: 'PRIMARY_MODAL_SECONDARY_PRIMARY_EXISTS_STATE',
  PRIMARY_MODAL_SECONDARY_ASSOCIATION_PRIMARY_DOESNT_EXIST_STATE: 'PRIMARY_MODAL_SECONDARY_ASSOCIATION_PRIMARY_DOESNT_EXIST_STATE',
  REMOVE_PRIMARY_ASSOCIATION_MODAL_STATE: 'REMOVE_PRIMARY_ASSOCIATION_MODAL_STATE',
  REMOVE_ASSOCIATION_MODAL_PRIMARY_ONLY_ASSOCIATION_STATE: 'REMOVE_ASSOCIATION_MODAL_PRIMARY_ONLY_ASSOCIATION_STATE',
  REMOVE_SECONDARY_ASSOCIATION_MODAL_STATE: 'REMOVE_SECONDARY_ASSOCIATION_MODAL_STATE',
  REMOVE_REVERSE_PRIMARY_MODAL_STATE: 'REMOVE_REVERSE_PRIMARY_MODAL_STATE',
  EDIT_ASSOCIATION_MODAL_STATE: 'EDIT_ASSOCIATION_MODAL_STATE'
};